<template>
    <div>
        <vapp-header btnMenu :tabList="tabItem"></vapp-header>

        <div class="list-group-fnc" v-if="items.length">
            <div v-for="(item, index) in sorted_items" :key="index" class="row no-gutters flex-nowrap p-3">
                <!-- <img class="pr-4 img-placeholder" src="@/assets/images/item-icon-tracking.svg"> -->

                <!-- Check if route is selling -->
                <div class="d-flex flex-column flex-grow-1" v-if="$route.params.cat == 'selling'">
                    <div class="d-flex justify-content-between">
                        <h5 class="mb-1 font-weight-bold">{{ item.name ? item.name : 'Not provided' }}</h5>
                        <h5 class="font-weight-bold text-green" v-if="item.track_inventory == true">{{ item.stock_balance ? item.stock_balance : 'Not provided' }} units</h5>
                    </div>
                    <h5 class="mb-1 text-gray">Item #{{ item.id }}</h5>
                    <h5 class="mb-1 font-weight-light">{{ item.sale_description ? item.sale_description : 'Not provided' }}</h5>
                </div>

                <!-- Check if route is buying -->
                <div class="d-flex flex-column flex-grow-1" v-else-if="$route.params.cat == 'tracking'">
                    <div class="d-flex justify-content-between">
                        <h5 class="mb-1 font-weight-bold">{{ item.name ? item.name : 'Not provided' }}</h5>
                        <h5 class="font-weight-bold text-green" v-if="item.track_inventory == true">{{ item.stock_balance ? item.stock_balance : 'Not provided' }} units</h5>
                    </div>
                    <h5 class="mb-1 text-gray">Item #{{ item.id }}</h5>
                    <h5 class="mb-1 font-weight-light">{{ item.purchase_description ? item.purchase_description : 'Not provided' }}</h5>
                </div>

                <!-- If route is 'all' check inside -->
                <div class="d-flex flex-column flex-grow-1" v-else>
                    <div v-if="item.for_sale">
                        <div class="d-flex justify-content-between">
                            <h5 class="mb-1 font-weight-bold">{{ item.name ? item.name : 'Not provided' }}</h5>
                            <h5 class="font-weight-bold text-green" v-if="item.track_inventory == true">{{ item.stock_balance ? item.stock_balance : 'Not provided' }} units</h5>
                        </div>
                        <h5 class="mb-1 text-gray">Item #{{ item.id }}</h5>
                        <h5 class="mb-1 font-weight-light">{{ item.sale_description ? item.sale_description : 'Not provided' }}</h5>
                    </div>
                    <div v-else>
                        <div class="d-flex justify-content-between">
                            <h5 class="mb-1 font-weight-bold">{{ item.name ? item.name : 'Not provided' }}</h5>
                            <h5 class="font-weight-bold text-green" v-if="item.track_inventory == true">{{ item.stock_balance ? item.stock_balance : 'Not provided' }} units</h5>
                        </div>
                        <h5 class="mb-1 text-gray">Item #{{ item.id }}</h5>
                        <h5 class="mb-1 font-weight-light">{{ item.purchase_description ? item.purchase_description : 'Not provided' }}</h5>
                    </div>
                </div>
            </div>
            <div class="bottomSpace"></div>
        </div>
        <div v-else-if="items.length === 0 && is_loading_api === false">
            <md-empty-state class="empty-state" v-if="!num_items && current_route_param == 'all'">
                <h1>Let's add your first item!</h1>
                <p>Create new item by clicking this button</p>
                <img src="@/assets/images/ic_arrow_point.svg">
            </md-empty-state>
            <md-empty-state class="empty-state" v-else-if="!num_items && current_route_param == 'selling'">
                <h1>Let's add your first item!</h1>
                <p>Create new item by clicking this button</p>
                <img src="@/assets/images/ic_arrow_point.svg">
            </md-empty-state>
            <md-empty-state class="empty-state" v-else-if="!num_items && current_route_param == 'buying'">
                <h1>Let's add your first item!</h1>
                <p>Create new item by clicking this button</p>
                <img src="@/assets/images/ic_arrow_point.svg">
            </md-empty-state>
        </div>

        <!--<vapp-right-panel :thepage="'/create_item'"></vapp-right-panel>-->

    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        data() {
            return {
                items: [],
                all_items: [],
                all_selling: [],
                all_buying:[],
                company_id: null,
                tabItem: {
                    name: 'item',
                    params: ['all', 'selling', 'buying']
                },
                is_loading_api: false,
            }
        },
        computed: {
            ...mapState('company', ['selectedCompany']),
            sorted_items: function() {
                return _.orderBy(this.items, 'sale_price', 'desc')
            },
            num_items: function() {
                return this.items.length
            },
            current_route_param: function() {
                return this.$route.params.cat
            }
        },
        mounted() {
            console.log("Mounted : Main/Items");

            //Use products/{business_id} to get all items
            this.$root.$emit('show-loading', true);
            this.is_loading_api = true;

            this.axios({
                method: 'get',
                url: 'products?business_id=' + this.selectedCompany,
            }).then(response => {
                this.$root.$emit('show-loading', false);
                this.is_loading_api = false;

                this.all_items = JSON.parse(JSON.stringify(response.data.products));

                for (var i = 0; i < this.all_items.length; i++) {
                    if (this.all_items[i].for_sale == true) {
                        this.all_selling.push(this.all_items[i])
                    } else if (this.all_items[i].for_purchase == true) {
                        this.all_buying.push(this.all_items[i])
                    }
                }
                this.items = this.all_items
            }).catch(error => {
                this.$root.$emit('show-loading', false);
                this.$generalAPIErrorHandling(error, this.$router);
            });
        },
        methods: {
            switchTab() {
                if (this.$route.params.cat == 'all') {
                    this.items = this.all_items;
                } else if (this.$route.params.cat == 'selling') {
                    this.items = this.all_selling;
                } else if (this.$route.params.cat == 'buying') {
                    this.items = this.all_buying;
                }
            },
            editItem(item) {
                this.$store.dispatch('set_item_being_edited', item, item.id)
                this.$router.push({ name: 'edit_item', params: { id: item.id } })
            },
        },
        watch: {
            '$route' : 'switchTab'
        }
    }
</script>
